import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-crisis-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './crisis-card.component.html',
  styleUrl: './crisis-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CrisisCardComponent {
  @Input() isCrisis = false;

  callICall(): void {
    if (typeof window === 'undefined') return;
    window.location.href = 'tel:9152987821';
  }
}
